import React from "react";
import { allData } from "data/allData";
import { Link } from "react-router-dom";
import styled from 'styled-components'

const Story = ({name, description, id, url}) => {

  const story = allData;
  
  // return(
  // <div>
  // {(allData && allData.index) &&
  // <div><p>{allData.index[0].title}HEJ</p></div>}
  // </div>
  // )

//   here I need to figure out how to link a certain image to a certain story,
//   it doesnt work using index because it always 
//  shows 0. Might try an if/else statement. if story[0] === ???


  return (
 
  
    <StoryWrapper>
   <StoryName>{story[0].name}</StoryName>
   <ImageBox>
   <StoryText><StoryImage src={story[0].url } /></StoryText>
   </ImageBox>
   <StoryText>{story[0].description}</StoryText>
   <StoryText>{story[0].id[1]}</StoryText>
   <LinkBack to="/post">Back to photos</LinkBack>

    </StoryWrapper>
     

  

  
  
  )
}

const StoryWrapper = styled.div`
width: 95vw;
display: flex;
flex-direction: column;
justify-content: center;
margin: 10px;
padding: 10px;
`

const StoryName = styled.h2`
padding-left: 20px;
padding-right: 20px;
margin: 0, 0, 10px, 0 ;
font-family: "aktiv-grotesk", sans-serif;
font-size: 40px;
font-weight: 600;
color: red;

@media (min-width: 375px) and (max-width: 912px) {
      font-size: 20px;  
    }
`

const StoryText = styled.h3`
/* font-family: 'Nuosu SIL', serif; */
font-family: "aktiv-grotesk", sans-serif;
font-weight: 300;
padding-left: 20px;
padding-right: 20px;
margin: 10px;

`
const ImageBox = styled.div`
width: 95vw;
display: flex;
justify-content: center;
align-items: center;
margin: 0;


`

const StoryImage = styled.img`
width: 100%;


@media (min-width: 375px) and (max-width: 912px) {
      width: 100%;
      padding:0;
      margin: 0;  
    }

`

const LinkBack = styled(Link)`
/* font-family: 'Nuosu SIL', serif; */
font-family: "aktiv-grotesk", sans-serif;
font-size: 15px;
text-decoration: none;
color: black;
width: 150px;
padding: 10px;

&:hover {
  background-color: yellow;
}
`



export default Story